export const isSamePathWithSpoof = (
  currentPath: string,
  expectedPath: string,
): boolean => {
  const spoofRoute = '/spoof';
  return (
    currentPath.replace(spoofRoute, '') === expectedPath.replace(spoofRoute, '')
  );
};
